import React, { useMemo } from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import PERMISSIONS from '../configs/permissions.json';
import { useCurrentUser } from 'utils/hooks/useCurrentUser';

const Routes = () => {
	const [user] = useCurrentUser();

	const filteredProtectedRoutes = useMemo(
		() =>
			protectedRoutes.filter(route => {
				if (route.transaccion) {
					const hasPermission = route.transaccion.some(permission =>
						PERMISSIONS.find(
							el => el?.role === user?.role?.type
						)?.permissions.includes(permission)
					);
					return hasPermission;
				}
				return true;
			}),
		[user]
	);

	return (
		<RouterRoutes>
			<Route path='/' element={<ProtectedRoute />}>
				<Route
					path='/'
					element={<Navigate replace to={AUTHENTICATED_ENTRY} />}
				/>
				{filteredProtectedRoutes.map((route, index) => {
					return (
						<Route
							key={route.key + index}
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key}
									component={route.component}
									{...route.meta}
								/>
							}
						/>
					);
				})}
				<Route path='*' element={<Navigate to='/' replace />} />
			</Route>
			<Route path='/' element={<PublicRoute />}>
				{publicRoutes.map(route => {
					return (
						<Route
							key={route.path}
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key}
									component={route.component}
									{...route.meta}
								/>
							}
						/>
					);
				})}
			</Route>
		</RouterRoutes>
	);
};

export default Routes;
